<template>
  <BModal
    :id="id"
    hide-footer
    hide-header
    :centered="true"
    content-class="rounded-lg"
    @hidden="uniqueNumber = ''"
  >
    <div
      class="position-absolute"
      style="right: 15px; top: 15px;"
    >
      <feather-icon
        icon="XIcon"
        class="cursor-pointer"
        @click="closeModal"
      />
    </div>
    <div class="text-center p-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Konfirmasi"
        class="mx-auto mb-2"
        width="120px"
      >
      <h1 class="font-semibold text-[18px] text-[#333333] mb-2">
        Konfirmasi Nominal Transfer
      </h1>
      <p class="text-[#737373] mb-2">
        Silakan masukan 3 digit terakhir nominal transfer pada dashboard provider guna verifikasi pembayaran
      </p>
      <div class="flex justify-content-center mb-2">
        <DigitInputGroup
          v-model="uniqueNumber"
          :length="3"
        />
      </div>
      <div class="flex items-between gap-[1rem] drawer-action">
        <BButton
          size="md"
          variant="light"
          block
          class="m-0"
          @click="closeModal"
        >
          Batalkan
        </BButton>
        <BButton
          size="md"
          variant="primary"
          block
          class="m-0"
          :class="{ 'cursor-not-allowed': !isCompleteInput }"
          :disabled="!isCompleteInput"
          @click.prevent="confirmModal"
        >
          Top Up Sekarang
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import DigitInputGroup from '@/@core/components/input/DigitInputGroup.vue'

export default {
  components: {
    DigitInputGroup,
  },
  props: {
    id: {
      type: String,
      default: 'modal-unique-number',
    },
  },
  data() {
    return {
      uniqueNumber: '',
    }
  },
  computed: {
    isCompleteInput() {
      return this.uniqueNumber.length === 3
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.id)
      this.$emit('on-close')
    },
    confirmModal() {
      this.$emit('on-confirm', { uniqueNumber: this.uniqueNumber })
      this.uniqueNumber = ''
    },
  },
}
</script>
